<template>
  <div>
    <v-dialog v-model="dialog" max-width="1000" persistent>
      <v-card>
        <v-container class="px-8 pt-8" style="width: 100%">
          <p class="subtitle-1 font-weight-bold mb-2">
            You have ({{ items.length }}) payments to catch up
          </p>
          <v-data-table
            fixed-header
            :items="items"
            :headers="headers"
            height="300"
            disable-pagination
            disable-filtering
            disable-sort
            hide-default-footer
            dense
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  <v-checkbox
                    v-model="item.selected"
                    class="mt-0"
                    hide-details
                    dense
                  ></v-checkbox>
                </td>
                <td>
                  <span v-if="item.selected">Rental</span>
                  <span v-else class="grey--text">Rental</span>
                </td>
                <td>
                  <div v-if="item.selected" class="d-flex flex-row">
                    <v-menu
                      v-if="item.selected"
                      v-model="item.startDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.startDate"
                          v-bind="attrs"
                          readonly
                          dense
                          hide-details
                          class="body-2"
                          v-on="on"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small class="mt-1"
                              >mdi-calendar-month</v-icon
                            >
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.startDate"
                        no-title
                        scrollable
                        @input="item.startDateMenu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                    <p>&nbsp;to&nbsp;</p>
                    <v-menu
                      v-if="item.selected"
                      v-model="item.endDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="item.endDate"
                          v-bind="attrs"
                          readonly
                          dense
                          hide-details
                          class="body-2"
                          v-on="on"
                        >
                          <template v-slot:prepend-inner>
                            <v-icon small class="mt-1"
                              >mdi-calendar-month</v-icon
                            >
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker
                        v-model="item.endDate"
                        no-title
                        scrollable
                        @input="item.endDateMenu = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
                  <span v-else class="grey--text"
                    >{{ item.startDate }} to {{ item.endDate }}</span
                  >
                </td>
                <td>
                  <v-menu
                    v-if="item.selected"
                    v-model="item.dueDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="item.dueDate"
                        v-bind="attrs"
                        readonly
                        dense
                        hide-details
                        class="body-2"
                        v-on="on"
                      >
                        <template v-slot:prepend-inner>
                          <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      v-model="item.dueDate"
                      no-title
                      scrollable
                      @input="item.dueDateMenu = false"
                    >
                    </v-date-picker>
                  </v-menu>
                  <v-text-field
                    v-else
                    v-model="item.dueDate"
                    readonly
                    dense
                    hide-details
                    disabled
                    class="body-2"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </td>
                <td>
                  <v-select
                    v-model="item.status"
                    dense
                    hide-details
                    :items="statuses"
                    :disabled="!item.selected"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon small class="mt-1">mdi-calendar-month</v-icon>
                    </template>
                    <template v-slot:selection="{ item, disabled }">
                      <p v-if="disabled" class="body-2 grey--text">
                        {{ item.text }}
                      </p>
                      <p v-else :class="selectionClass(item.value)">
                        {{ item.text }}
                      </p>
                    </template>
                    <template v-slot:item="{ item }">
                      <p v-if="item.disabled" class="body-2 grey--text">
                        {{ item.text }}
                      </p>
                      <p v-else :class="selectionClass(item.value)">
                        {{ item.text }}
                      </p>
                    </template>
                  </v-select>
                </td>
                <td>
                  <span v-if="item.selected">{{
                    formatCurrency(item.rentFee)
                  }}</span>
                  <span v-else class="grey--text">{{
                    formatCurrency(item.rentFee)
                  }}</span>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-card-actions>
            <v-checkbox v-model="confirmSendEmail">
              <template v-slot:label> Send email to tenant </template>
            </v-checkbox>
            <v-spacer></v-spacer>
            <v-btn
              class="font-weight-bold"
              color="primary darken-1"
              text
              :disabled="!paymentRequestAccess.create"
              @click="finish"
              >Create Payments</v-btn
            >
            <v-btn
              class="font-weight-bold"
              color="grey darken-1"
              text
              @click="cancel"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { dayjs } from '../../util/date'

export default {
  data() {
    return {
      dialog: false,
      items: [],
      bedDetails: null,
      headers: [
        { text: 'Select' },
        { text: 'Category', value: 'category' },
        { text: 'Period' },
        { text: 'Due Date', value: 'dueDate' },
        { text: 'Status', value: 'status', width: '20%' },
        { text: 'Amount', value: 'amount' }
      ],
      confirmSendEmail: false
    }
  },
  computed: {
    paymentRequestAccess() {
      return this.$root.$roleAccess('paymentrequest').access
    },
    paidPaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    statuses() {
      return [
        {
          text: 'Pending',
          value: 'pending',
          disabled: !this.paymentRequestAccess.create
        },
        {
          text: 'Paid',
          value: 'paid',
          disabled: !this.paidPaymentAccess.create
        }
      ]
    }
  },
  methods: {
    async open(params) {
      this.dialog = true
      this.confirmSendEmail = false
      this.items = JSON.parse(
        JSON.stringify(
          params.rentalsToMake.map((item) => {
            item.selected = true
            item.dueDateMenu = false
            item.startDateMenu = false
            item.endDateMenu = false
            item.status = 'pending'
            item.dueDate = dayjs(item.dueDate).format('YYYY-MM-DD')
            item.startDate = dayjs(item.startDate).format('YYYY-MM-DD')
            item.endDate = dayjs(item.endDate).format('YYYY-MM-DD')
            return item
          })
        )
      )
      this.bedDetails = params.bedDetails

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    async finish() {
      if (
        await this.$root.$confirm({
          title: 'Catch Up Rental Payments',
          message:
            'Are you sure you would like to create the following rental payments?'
        })
      ) {
        this.$root.$setLoading(true)
        for (let index in this.items) {
          const item = this.items[index]
          if (item.selected) {
            await this.$store.dispatch('payments/collectUtilities', {
              tenantId: this.bedDetails.tenantId,
              bedId: this.bedDetails.bedId,
              category: 'rental',
              description: `Rental for ${this.bedDetails.bedName} from ${dayjs(
                item.startDate
              ).format('MMMM D, YYYY')} to ${dayjs(item.endDate).format(
                'MMMM D, YYYY'
              )}`,
              amount: item.rentFee,
              startDate: dayjs(item.startDate).format(),
              endDate: dayjs(item.endDate).format(),
              leaseId: this.bedDetails.leaseId,
              dueDate: dayjs(item.dueDate).format(),
              confirmSendEmail: this.confirmSendEmail,
              status: item.status
            })
          }
        }

        await this.$root
          .$confirm({
            title: 'Catch Up Rental Payments',
            message: `The payments have been created.`,
            reconfirmOnly: true,
            confirmText: 'OK',
            options: {
              color: 'success'
            }
          })
          .then(() => {
            this.$root.$setLoading(false)
            this.dialog = false
            this.resolve(true)
          })
      }
    },
    cancel() {
      this.dialog = false
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    selectionClass(value) {
      switch (value) {
        case 'pending':
          return 'body-2 red--text'
        case 'paid':
          return 'body-2 '
      }
    }
  }
}
</script>
